var _defs, _rect, _rect2, _path, _g, _g2, _g3, _g4, _g5, _g6, _rect3, _path2, _g7, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g8, _rect4, _path14, _rect5, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _rect6, _path85, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _rect13, _rect14, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWellnessFeatureCallDoctor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199424",
    "data-name": "Rectangle 199424",
    width: 300,
    height: 250.652,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199400",
    "data-name": "Rectangle 199400",
    width: 10.738,
    height: 10.739,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199401",
    "data-name": "Rectangle 199401",
    width: 3.125,
    height: 8.302,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199402",
    "data-name": "Rectangle 199402",
    width: 10.74,
    height: 10.74,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199403",
    "data-name": "Rectangle 199403",
    width: 7.037,
    height: 5.946,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199404",
    "data-name": "Rectangle 199404",
    width: 10.739,
    height: 10.739,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199405",
    "data-name": "Rectangle 199405",
    width: 4.655,
    height: 7.807,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199407",
    "data-name": "Rectangle 199407",
    width: 20.908,
    height: 31.385,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199409",
    "data-name": "Rectangle 199409",
    width: 16.238,
    height: 28.204,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "wellness-feature-call-doctor",
    transform: "translate(-5136 16482)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199375",
    "data-name": "Rectangle 199375",
    width: 300,
    height: 300,
    transform: "translate(5136 -16482)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_233405",
    "data-name": "Group 233405",
    transform: "translate(5136 -16460)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233438",
    "data-name": "Group 233438",
    transform: "translate(0 0.001)",
    clipPath: "url(#clip-path)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199399",
    "data-name": "Rectangle 199399",
    width: 58.793,
    height: 44.93,
    transform: "translate(16.105 2.679)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_424093",
    "data-name": "Path 424093",
    d: "M154.072,60.19H94.923V14.9h59.149ZM95.28,59.834h58.436V15.26H95.28Z",
    transform: "translate(-78.996 -12.403)",
    fill: "#859fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_233407",
    "data-name": "Group 233407",
    transform: "translate(26.865 30.296)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_233406",
    "data-name": "Group 233406"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233405-2",
    "data-name": "Group 233405",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_424094",
    "data-name": "Path 424094",
    d: "M165.478,180.558a5.37,5.37,0,1,0,5.372,5.369,5.368,5.368,0,0,0-5.372-5.369",
    transform: "translate(-160.112 -180.558)",
    fill: "#0095d9"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_233410",
    "data-name": "Group 233410",
    transform: "translate(30.837 31.568)",
    style: {
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_233409",
    "data-name": "Group 233409"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233408",
    "data-name": "Group 233408",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_424095",
    "data-name": "Path 424095",
    d: "M184.822,188.248c-.03-.115-.283-.146-.572-.07s-.494.232-.464.347l2.09,7.8c.03.115.283.146.572.07s.488-.232.458-.347Z",
    transform: "translate(-183.784 -188.137)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_233413",
    "data-name": "Group 233413",
    transform: "translate(38.781 14.814)",
    style: {
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_233412",
    "data-name": "Group 233412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233411",
    "data-name": "Group 233411",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_424096",
    "data-name": "Path 424096",
    d: "M233.327,89.33a5.369,5.369,0,1,0,7.505,1.167,5.368,5.368,0,0,0-7.505-1.167",
    transform: "translate(-231.127 -88.294)",
    fill: "#0095d9"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_233416",
    "data-name": "Group 233416",
    transform: "translate(40.798 17.155)",
    style: {
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_233415",
    "data-name": "Group 233415"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233414",
    "data-name": "Group 233414",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_424097",
    "data-name": "Path 424097",
    d: "M243.863,102.264c-.092-.075-.315.049-.5.281s-.262.479-.17.554l6.29,5.068c.092.075.315-.049.5-.281s.257-.475.165-.55Z",
    transform: "translate(-243.151 -102.242)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_233419",
    "data-name": "Group 233419",
    transform: "translate(24.315 9.154)",
    style: {
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_233418",
    "data-name": "Group 233418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233417",
    "data-name": "Group 233417",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_424098",
    "data-name": "Path 424098",
    d: "M153.882,55.941a5.369,5.369,0,1,0,.387,7.586,5.368,5.368,0,0,0-.387-7.586",
    transform: "translate(-144.915 -54.557)",
    fill: "#0095d9"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_233422",
    "data-name": "Group 233422",
    transform: "translate(27.447 10.772)",
    style: {
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_233421",
    "data-name": "Group 233421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233420",
    "data-name": "Group 233420",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_424099",
    "data-name": "Path 424099",
    d: "M167.845,64.318c-.261-.133-.522-.159-.577-.053l-3.68,7.19c-.055.106.112.3.378.435s.517.155.572.049l3.684-7.187c.055-.106-.112-.3-.378-.435",
    transform: "translate(-163.578 -64.199)",
    fill: "#fff"
  }))))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199406",
    "data-name": "Rectangle 199406",
    width: 70.364,
    height: 51.516,
    transform: "translate(0.178 155.083)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424100",
    "data-name": "Path 424100",
    d: "M70.72,975.084H0V923.211H70.72ZM.357,974.727H70.364v-51.16H.357Z",
    transform: "translate(0 -768.306)",
    fill: "#859fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_233425",
    "data-name": "Group 233425",
    transform: "translate(29.971 167.262)",
    style: {
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_233424",
    "data-name": "Group 233424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233423",
    "data-name": "Group 233423",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_424101",
    "data-name": "Path 424101",
    d: "M198.118,999.729l-10.435-2.808a1.9,1.9,0,0,0-2.332,1.344l-6.665,24.768a1.9,1.9,0,0,0,1.343,2.333l10.435,2.808a1.9,1.9,0,0,0,2.334-1.344l6.665-24.768a1.9,1.9,0,0,0-1.344-2.333",
    transform: "translate(-178.62 -996.856)",
    fill: "#c4d5ff"
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424102",
    "data-name": "Path 424102",
    d: "M227.558,1012.742a1.741,1.741,0,1,0,1.229,2.133,1.741,1.741,0,0,0-1.229-2.133",
    transform: "translate(-187.551 -842.765)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424103",
    "data-name": "Path 424103",
    d: "M271.358,1024.528a1.741,1.741,0,1,0,1.229,2.133,1.741,1.741,0,0,0-1.229-2.133",
    transform: "translate(-224.001 -852.573)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424104",
    "data-name": "Path 424104",
    d: "M218.545,1045.6a1.741,1.741,0,1,0,1.229,2.133,1.741,1.741,0,0,0-1.229-2.133",
    transform: "translate(-180.05 -870.105)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424105",
    "data-name": "Path 424105",
    d: "M262.344,1057.381a1.741,1.741,0,1,0,1.229,2.134,1.741,1.741,0,0,0-1.229-2.134",
    transform: "translate(-216.5 -879.914)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424106",
    "data-name": "Path 424106",
    d: "M210.9,1075.849a1.741,1.741,0,1,0,1.229,2.133,1.741,1.741,0,0,0-1.229-2.133",
    transform: "translate(-173.685 -895.283)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424107",
    "data-name": "Path 424107",
    d: "M254.7,1087.638a1.741,1.741,0,1,0,1.229,2.133,1.742,1.742,0,0,0-1.229-2.133",
    transform: "translate(-210.135 -905.094)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424108",
    "data-name": "Path 424108",
    d: "M203.349,1105.14a1.741,1.741,0,1,0,1.229,2.133,1.741,1.741,0,0,0-1.229-2.133",
    transform: "translate(-167.403 -919.659)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424109",
    "data-name": "Path 424109",
    d: "M247.148,1116.926a1.741,1.741,0,1,0,1.229,2.133,1.741,1.741,0,0,0-1.229-2.133",
    transform: "translate(-203.853 -929.468)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424110",
    "data-name": "Path 424110",
    d: "M195.681,1134.236a1.741,1.741,0,1,0,1.229,2.133,1.741,1.741,0,0,0-1.229-2.133",
    transform: "translate(-161.021 -943.873)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424111",
    "data-name": "Path 424111",
    d: "M239.49,1146.023a1.741,1.741,0,1,0,1.229,2.133,1.741,1.741,0,0,0-1.229-2.133",
    transform: "translate(-197.481 -953.682)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424112",
    "data-name": "Path 424112",
    d: "M228.23,1018.71a.178.178,0,0,0-.218.127l-6.4,24.291a.178.178,0,0,0,.127.218.184.184,0,0,0,.045.006.178.178,0,0,0,.172-.133l6.4-24.291a.178.178,0,0,0-.127-.218",
    transform: "translate(-184.427 -847.776)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_233428",
    "data-name": "Group 233428",
    transform: "translate(12.447 167.051)",
    style: {
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_233427",
    "data-name": "Group 233427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233426",
    "data-name": "Group 233426",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199408",
    "data-name": "Rectangle 199408",
    width: 12.317,
    height: 26.637,
    transform: "matrix(0.988, -0.153, 0.153, 0.988, 0, 1.879)",
    fill: "#c4d5ff"
  }))))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199410",
    "data-name": "Rectangle 199410",
    width: 13.033,
    height: 2.062,
    transform: "matrix(0.988, -0.153, 0.153, 0.988, 11.808, 166.984)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424113",
    "data-name": "Path 424113",
    d: "M68.375,985.764l-.424-2.742,13.585-2.1.424,2.742Zm.39-2.147.206,1.333,12.175-1.88-.206-1.333Z",
    transform: "translate(-56.55 -816.335)",
    fill: "#c4d5ff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199411",
    "data-name": "Rectangle 199411",
    width: 11.052,
    height: 8.66,
    transform: "matrix(0.988, -0.153, 0.153, 0.988, 14.495, 178.162)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424114",
    "data-name": "Path 424114",
    d: "M1459.7,343.388c-1.685-4.288-.9-8.143-.465-11.465s-9.734-.83-8.924,2.687.736,6.609-.309,8.1-2.949,1.954-3.183,2.887c-.317,1.267,1.883,2.986,7.135,3.183,6.177.26,9.634-2.211,8.762-3.487-.54-.791-2.384-.294-3.016-1.9",
    transform: "translate(-1204.032 -274.93)",
    fill: "#f5bd9f"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424115",
    "data-name": "Path 424115",
    d: "M1434.067,268.855c-.251,3.031-1.167,15.2,4.379,16.909,3.6,1.108,7.311-.476,10.3-3.833s1.424-9.322.113-11.257-14.54-4.849-14.791-1.818",
    transform: "translate(-1193.268 -222.653)",
    fill: "#f5bd9f"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424116",
    "data-name": "Path 424116",
    d: "M1479.341,309.2c-1.052-.126-1.266,2.03-.282,2.232s1.49-2.085.282-2.232",
    transform: "translate(-1230.361 -257.316)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424117",
    "data-name": "Path 424117",
    d: "M1445.553,304.988c-1.062-.073-1.162,2.1-.163,2.25s1.378-2.167.163-2.25",
    transform: "translate(-1202.29 -253.813)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424118",
    "data-name": "Path 424118",
    d: "M1454.831,352.879a1.507,1.507,0,0,1-1.146.389,1.391,1.391,0,0,1-.952-.618.181.181,0,1,0-.294.21,1.741,1.741,0,0,0,1.2.766,1.543,1.543,0,0,0,.2.012,1.924,1.924,0,0,0,1.227-.483.181.181,0,1,0-.232-.277",
    transform: "translate(-1208.708 -293.417)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424119",
    "data-name": "Path 424119",
    d: "M1453.4,311.331a.181.181,0,1,0-.361-.009,3.413,3.413,0,0,1-1.032,2.13c-.312.367-.558.657-.558.964,0,.747.836.822,1.286.863l.092.009h.018a.181.181,0,0,0,.018-.361l-.1-.009c-.607-.055-.958-.155-.957-.5,0-.175.23-.445.473-.731a3.759,3.759,0,0,0,1.117-2.355",
    transform: "translate(-1207.914 -258.939)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424120",
    "data-name": "Path 424120",
    d: "M1446.058,298.435a2.46,2.46,0,0,0-1.185.091.181.181,0,0,0,.08.343.178.178,0,0,0,.08-.019,2.258,2.258,0,0,1,.99-.055.181.181,0,1,0,.036-.36",
    transform: "translate(-1202.354 -248.335)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424121",
    "data-name": "Path 424121",
    d: "M1484.694,304.5a2.436,2.436,0,0,0-1.06-.476.179.179,0,0,0-.19.171.181.181,0,0,0,.171.19,2.23,2.23,0,0,1,.878.415l.022.015a.179.179,0,0,0,.1.031.181.181,0,0,0,.1-.331Z",
    transform: "translate(-1234.537 -253.016)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424122",
    "data-name": "Path 424122",
    d: "M1427.436,232.539c-1.415-1.94-3.7-.345-5.752-1.3s-2.521-3.947-5.895-4.288c-3.872-.395-3.15,3.994-4.208,4.591s-5.038-1.2-6.184.237,1.148,5.073,3.269,5.432,3.942-2.193,5.729-1.9c2.169.369,2.418,1.727,3.867,2.216a6.743,6.743,0,0,0,4.809-.143c-.176,1.283-.633,3.344-.026,4.8,4.566-1.511,2.639,5.808-.062,3.883.376,5.5,4.034,1.969,5.329-.958s-.859-4.94-.9-6.546,1.881-3.484.028-6.032",
    transform: "translate(-1169.332 -188.851)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424123",
    "data-name": "Path 424123",
    d: "M1467.266,228.452c-2.031.322-3.187-1.108-4.2-2.6a6.155,6.155,0,0,0-3.86-2.569,4.554,4.554,0,0,0-3.6,1.018.181.181,0,0,0,.221.286,4.2,4.2,0,0,1,3.323-.947,5.846,5.846,0,0,1,3.617,2.415c.93,1.373,2.069,2.8,3.934,2.8a3.949,3.949,0,0,0,.62-.05.181.181,0,0,0-.057-.357",
    transform: "translate(-1211.314 -185.773)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424124",
    "data-name": "Path 424124",
    d: "M1421.943,276.314a3.769,3.769,0,0,0-3.035,1.314c-.934.828-1.818,1.61-3.574,1.073a7.012,7.012,0,0,1-1.942-1.03.181.181,0,0,0-.2.3,7.3,7.3,0,0,0,2.04,1.077,4.084,4.084,0,0,0,1.194.194,4,4,0,0,0,2.726-1.343,3.438,3.438,0,0,1,2.759-1.225.181.181,0,0,0,.036-.36",
    transform: "translate(-1176.005 -229.938)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424125",
    "data-name": "Path 424125",
    d: "M1511.026,341.829l.024-.235a.181.181,0,1,0-.359-.036l-.024.232a3.967,3.967,0,0,0,.075,1.717.181.181,0,0,0,.173.129.176.176,0,0,0,.052-.008.181.181,0,0,0,.122-.225,3.64,3.64,0,0,1-.062-1.577",
    transform: "translate(-1257.145 -284.113)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424126",
    "data-name": "Path 424126",
    d: "M1430.4,1326.191l7.911,1.127,1.792-16.466-9.129.154Z",
    transform: "translate(-1190.396 -1090.905)",
    fill: "#f5bd9f"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424127",
    "data-name": "Path 424127",
    d: "M1519.965,1366.469l7.974.56.609-16.557-9.094.812Z",
    transform: "translate(-1264.505 -1123.877)",
    fill: "#f5bd9f"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424128",
    "data-name": "Path 424128",
    d: "M1321.449,1434.741c-.4.42-.917,1.428-.217,1.484s27.149.035,27.87,0,.21-2.646-.217-3.514c-2.877.539-26.435,2.03-27.436,2.03",
    transform: "translate(-1099.256 -1192.317)",
    fill: "#afe7fc"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424129",
    "data-name": "Path 424129",
    d: "M1341.029,1374.381c-12.118,6.924-16.823,8.772-16.795,11.789,6-.175,21.464-.658,27.527-1.967a20.25,20.25,0,0,0-.21-7.673c-3.367,1.582-8.919.9-10.522-2.149",
    transform: "translate(-1102.042 -1143.774)",
    fill: "#111"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424130",
    "data-name": "Path 424130",
    d: "M1401.88,1382.971a.181.181,0,0,0-.285.222l1.854,2.386a.181.181,0,0,0,.286-.222Z",
    transform: "translate(-1166.39 -1150.865)",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424131",
    "data-name": "Path 424131",
    d: "M1388.073,1390.693a.181.181,0,0,0-.292.214l1.8,2.463a.181.181,0,1,0,.292-.214Z",
    transform: "translate(-1154.897 -1157.288)",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424132",
    "data-name": "Path 424132",
    d: "M1374.141,1398.709a.181.181,0,0,0-.3.2l1.546,2.274a.181.181,0,1,0,.3-.2Z",
    transform: "translate(-1143.299 -1163.955)",
    fill: "#fff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424133",
    "data-name": "Path 424133",
    d: "M1413.472,1474.746c-.392.42-.91,1.428-.217,1.484s27.149.035,27.877,0,.2-2.646-.217-3.507c-2.884.532-26.442,2.023-27.443,2.023",
    transform: "translate(-1175.842 -1225.616)",
    fill: "#afe7fc"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424134",
    "data-name": "Path 424134",
    d: "M1433.029,1414.353c-12.118,6.924-16.816,8.772-16.795,11.789,6.006-.175,21.464-.658,27.534-1.967a20.386,20.386,0,0,0-.217-7.673c-3.367,1.582-8.912.9-10.522-2.149",
    transform: "translate(-1178.605 -1177.039)",
    fill: "#111"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424135",
    "data-name": "Path 424135",
    d: "M1493.88,1422.942a.181.181,0,1,0-.285.222l1.854,2.386a.181.181,0,1,0,.285-.222Z",
    transform: "translate(-1242.954 -1184.129)",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424136",
    "data-name": "Path 424136",
    d: "M1480.114,1430.665a.181.181,0,0,0-.292.213l1.8,2.463a.181.181,0,1,0,.292-.213Z",
    transform: "translate(-1231.494 -1190.553)",
    fill: "#fff"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424137",
    "data-name": "Path 424137",
    d: "M1466.182,1438.68a.181.181,0,1,0-.3.2l1.546,2.274a.181.181,0,1,0,.3-.2Z",
    transform: "translate(-1219.897 -1197.219)",
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424138",
    "data-name": "Path 424138",
    d: "M1394.829,691.905c-2.967,35.145.941,84.3,2.127,106.466,3.72.627,12.387,1.234,12.387,1.234l.493,5.976s13.278.071,17.032-.148c3.744-27.29,7.9-84.02,4.424-114.6-4.433.2-23.142-.211-36.462,1.075",
    transform: "translate(-1159.885 -574.916)",
    fill: "#6eb9e4"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424139",
    "data-name": "Path 424139",
    d: "M1437.93,837.846a.181.181,0,0,0-.178-.183.178.178,0,0,0-.183.178c-.255,18.66,5.892,69.009,8.547,89.791a.181.181,0,0,0,.179.158h.023a.181.181,0,0,0,.156-.2c-2.654-20.774-8.8-71.1-8.544-89.74",
    transform: "translate(-1196.353 -697.112)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424140",
    "data-name": "Path 424140",
    d: "M1468.47,809.777c-1.321-.963-1.766-2.518-3.07-3.505a11.558,11.558,0,0,1-1.178-1.176c-1.706,1.889-4.1,4.459-4.315,4.678-1.4,1.442-.074,3.112,1.1,2.125-1.109.953-2.313,2.243-3.232,3.1-1.11,1.038-.057,3.4,1.552,2.1-1.006,1.237.615,3.471,3.467.352-.893.884.343,3.123,2.307,1.376a83.646,83.646,0,0,0,6.339-6.543,10.111,10.111,0,0,1-1.4-1.107c-.235-.227-2.105-1.766-1.575-1.407",
    transform: "translate(-1212.793 -670.009)",
    fill: "#f5bd9f"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424141",
    "data-name": "Path 424141",
    d: "M1477.6,831.576a21.814,21.814,0,0,1-2.743,2.6.181.181,0,1,0,.216.29,22.324,22.324,0,0,0,2.806-2.654.181.181,0,0,0-.278-.231",
    transform: "translate(-1227.334 -691.992)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424142",
    "data-name": "Path 424142",
    d: "M1470.584,852.174c-.67.777-3.581,3.392-4.565,4.257a.181.181,0,1,0,.239.271c.989-.869,3.917-3.5,4.6-4.293a.181.181,0,0,0-.274-.236",
    transform: "translate(-1219.985 -709.136)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424143",
    "data-name": "Path 424143",
    d: "M1489.449,862.367a18.407,18.407,0,0,1-2.557,2.608c-.2.181-.387.348-.549.5a.181.181,0,1,0,.245.266c.161-.148.346-.315.545-.494a18.586,18.586,0,0,0,2.614-2.673.181.181,0,1,0-.3-.2",
    transform: "translate(-1236.902 -717.605)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424144",
    "data-name": "Path 424144",
    d: "M1410.067,396.53c-2.671,3.664-10.067,8.378-10.895,1-4.877,2.537-12.529,25.994-12.546,51.229,6.961.722,17.745-.343,22.356-.878.246,6.577-1.156,12.193-4.73,17.245a107.175,107.175,0,0,0,9.066,8.787c8.443-11.7,7.934-21.888,8.4-26.132a42.541,42.541,0,0,0,5.4-.56c-3.787-42.319-12.307-47.921-17.053-50.689",
    transform: "translate(-1153.964 -329.997)",
    fill: "#6383db"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424145",
    "data-name": "Path 424145",
    d: "M1542.134,472.6a.181.181,0,0,0-.059.249c4.62,7.512,14.637,36.374,4.264,58.009a.181.181,0,1,0,.326.156c10.438-21.77.365-50.8-4.282-58.355a.181.181,0,0,0-.249-.059",
    transform: "translate(-1283.308 -393.283)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424146",
    "data-name": "Path 424146",
    d: "M1489.325,491.911c2.027,9.337,2.608,26.62,2.176,35.32a18.406,18.406,0,0,1,2.963-.23c1.28-10.27-5.917-38.658-5.139-35.09",
    transform: "translate(-1239.383 -409.117)",
    fill: "#1e4586"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424147",
    "data-name": "Path 424147",
    d: "M433.342,92.743H351.466a9.155,9.155,0,0,0-9.155,9.155V286.4a9.155,9.155,0,0,0,9.155,9.155h81.876A9.155,9.155,0,0,0,442.5,286.4V101.9a9.155,9.155,0,0,0-9.155-9.155",
    transform: "translate(-284.875 -77.182)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424148",
    "data-name": "Path 424148",
    d: "M442.454,107.194h-79.3a8.347,8.347,0,0,0-8.347,8.347v181.09a8.347,8.347,0,0,0,8.347,8.347h79.3a8.347,8.347,0,0,0,8.347-8.347V115.541a8.347,8.347,0,0,0-8.347-8.347",
    transform: "translate(-295.277 -89.208)",
    fill: "#fff"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424149",
    "data-name": "Path 424149",
    d: "M528.062,249.81c-1.7-1.271-2.427-2.051-1.8-4.478s-1.156-4.8-4-5.22-3.958-1.387-3.958-4.709-3.535,1.868,1.04-6.867-2.282-7.281-5.133-9.226c-1.647-1.127-1.868-3.265-4.786-3.467s-2.908,1.936-5.682,2.562-4.151-2.282-7.425-.626c-3.949,2.013-1.733,5-3.6,7.011s-5.133,1.108-6.173,4.854c-.77,2.774,1.733,3.188,1.522,6.173s-4.161,2.148-4.228,7,2.639,4.026,2.841,6.318-2.976,3.255-2.215,7,3.332,1.522,4.854,2.427,1.733,3.467,4.44,2.908,4.575-3.39,7.213-3.881,7.907,1.8,11.229,1.454,4.787-2.706,6.944-3.669,3.689,1.011,7.7.029c2.379-.587,3.342-4.016,1.213-5.6",
    transform: "translate(-402.654 -179.614)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424150",
    "data-name": "Path 424150",
    d: "M561.786,365.85c-1.394-2.633-1.228-7.884.263-13.77s-13.117-11.155-12.783-5.475,2.456,12.328-.38,19.43c-1.063,2.663-5.019,1.607-5.877,2.894-1.383,2.075,3.441,6.622,12.476,6.814,7.679.2,11.041-2.486,10.689-4.669-.259-1.607-3-2.592-4.389-5.224",
    transform: "translate(-451.703 -286.422)",
    fill: "#f5bd9f"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424151",
    "data-name": "Path 424151",
    d: "M550.623,243.911c-4.141.742-10.642,6.953-9.669,12.481-6.684-.693-3.457,10.132,1.377,6.636,3.554,8.571,9.785,10.96,14.947,9.438,5.277-1.551,7.907-15.707,5.374-23.9-1.541-4.96-7.878-5.384-12.029-4.652",
    transform: "translate(-447.028 -202.752)",
    fill: "#f5bd9f"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424152",
    "data-name": "Path 424152",
    d: "M560.46,236.163c-6.674,2.9-10.266,12.395-7.367,13.078,4.334,1.031,9.765-7.367,11.1-10.035,3.679,5.615,8.4,1.724,10.449,4.209,1.223,1.483.3,5.461,1.464,5.441s4.873-6.173.944-10.844c-.771-.925-9.91-4.748-16.594-1.849",
    transform: "translate(-459.447 -195.65)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424153",
    "data-name": "Path 424153",
    d: "M652.325,317.071a.178.178,0,1,0-.355.027,6.746,6.746,0,0,0,1.086,2.962,3.362,3.362,0,0,1,.55,1.262c.033.647-.633.735-1.442.779l-.125.007a.178.178,0,0,0,.01.356h.011l.122-.007c.641-.034,1.833-.1,1.779-1.153a3.538,3.538,0,0,0-.6-1.423,6.451,6.451,0,0,1-1.039-2.81",
    transform: "translate(-542.496 -263.733)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424154",
    "data-name": "Path 424154",
    d: "M672.189,298.457a3.311,3.311,0,0,0-2.363.054.178.178,0,0,0,.076.34.177.177,0,0,0,.075-.017,2.926,2.926,0,0,1,2.087-.043.178.178,0,0,0,.125-.334",
    transform: "translate(-557.351 -248.22)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424155",
    "data-name": "Path 424155",
    d: "M647.7,384.42a1.35,1.35,0,0,1-1.966.425.178.178,0,1,0-.212.287,1.675,1.675,0,0,0,.988.329,1.833,1.833,0,0,0,1.476-.828.178.178,0,0,0-.286-.213",
    transform: "translate(-537.146 -319.859)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424156",
    "data-name": "Path 424156",
    d: "M615.487,303.274a3.352,3.352,0,0,0-2.287.585.178.178,0,1,0,.218.282,3.017,3.017,0,0,1,2.027-.513.178.178,0,1,0,.041-.354",
    transform: "translate(-510.254 -252.372)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424157",
    "data-name": "Path 424157",
    d: "M618.17,317.168c-1.281.385-.838,3.274.539,2.947s.7-3.332-.539-2.947",
    transform: "translate(-513.814 -263.922)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424158",
    "data-name": "Path 424158",
    d: "M673.139,312.229c-1.32.231-1.233,3.159.173,3s1.117-3.217-.173-3",
    transform: "translate(-559.413 -259.831)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424159",
    "data-name": "Path 424159",
    d: "M717.19,369.668c-1.683-1.008-2-2.538-2.315-4.018-.466-2.221-.907-4.319-5.655-4.319a.178.178,0,0,0,0,.357c4.458,0,4.851,1.87,5.306,4.036.311,1.482.664,3.162,2.48,4.25a.178.178,0,0,0,.183-.306",
    transform: "translate(-590.072 -300.704)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424160",
    "data-name": "Path 424160",
    d: "M1276.879,481.963a5.463,5.463,0,1,0,5.1,5.447,5.283,5.283,0,0,0-5.1-5.447",
    transform: "translate(-1058.384 -401.095)",
    fill: "#3266af"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424161",
    "data-name": "Path 424161",
    d: "M1289.908,498.866a2.639,2.639,0,1,0,2.364,2.625,2.5,2.5,0,0,0-2.364-2.625",
    transform: "translate(-1071.508 -415.162)",
    fill: "#6eb9e4"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424162",
    "data-name": "Path 424162",
    d: "M935.376,458.59c-4.918-3.9-12.405-.354-17.438,6.437-5.9,7.965-36.84,25.322-55.424,12.678l1.345,17.676,1.857-.333c22.655,1.7,43.06-7.141,56.852-17.936,2.326-1.821,7.825-2.4,10.539-3.678s3.228-4.571,1.765-5.238-1.941,1.462-4,1.864c-5.1,1-3.844-7.671.931-4.42,1.571,1.071,4.169,1.211,3.662-1.754a2.941,2.941,0,0,0-.82-1.306,2.285,2.285,0,0,1,.422.354c1.887,2.482,4.533-1,.311-4.344",
    transform: "translate(-717.793 -380.299)",
    fill: "#f5bd9f"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424163",
    "data-name": "Path 424163",
    d: "M1249.955,478.284a6.319,6.319,0,0,0-6.107.69.178.178,0,0,0,.22.28,5.961,5.961,0,0,1,5.759-.638,4.1,4.1,0,0,1,2.762,2.631.178.178,0,0,0,.176.148l.03,0a.178.178,0,0,0,.146-.206,4.384,4.384,0,0,0-2.986-2.9",
    transform: "translate(-1035.087 -397.636)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424164",
    "data-name": "Path 424164",
    d: "M564.26,459.857l-11.785-5.667-1.953.815,15.164,22.874,5.625-4.2,1.754-19.164-3.094-1.3Z",
    transform: "translate(-458.149 -377.167)",
    fill: "#fff"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424165",
    "data-name": "Path 424165",
    d: "M501.808,471.207c-12.562-10.6-14.723-12.4-29.031-16.445-1.091,6.881-4.064,21.032-4.064,21.032s-13.974-13.785-18.608-20.435c-4.848,1.569-7.65,2.994-12.084,4.706s-1.383,24.877-1.789,34.045c-1.127,9.766-6.191,55.914-5.989,69.817,20.555.4,67.745-3.123,75.4-3.224-1.282-20.8-4.08-49.482-6.445-65.788,16.94,8.506,41.386,8.65,63.9-17.591-2.3-2.949-7.927-9.357-10.437-12.524-19.085,16.55-38.342,16.957-50.854,6.406",
    transform: "translate(-358.047 -378.458)",
    fill: "#0095d9"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424166",
    "data-name": "Path 424166",
    d: "M570.015,457.659l-11.364-6.35-1.162.9,10.423,10.567,2.118-4.821,3.807,3.305,3.115-9.86-1.233-.546Z",
    transform: "translate(-463.948 -375.208)",
    fill: "#6383db"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424167",
    "data-name": "Path 424167",
    d: "M710.494,1026.665a1.257,1.257,0,1,0,1.255,1.257,1.257,1.257,0,0,0-1.255-1.257",
    transform: "translate(-590.236 -854.401)",
    fill: "#3266af"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424168",
    "data-name": "Path 424168",
    d: "M689.828,722.654a1.257,1.257,0,1,0,1.255,1.257,1.257,1.257,0,0,0-1.255-1.257",
    transform: "translate(-573.038 -601.4)",
    fill: "#3266af"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424169",
    "data-name": "Path 424169",
    d: "M678.065,634.048a1.257,1.257,0,1,0,1.255,1.257,1.258,1.258,0,0,0-1.255-1.257",
    transform: "translate(-563.242 -527.661)",
    fill: "#3266af"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424170",
    "data-name": "Path 424170",
    d: "M672.308,461.534a.178.178,0,0,0-.015.252,16.057,16.057,0,0,1,3.777,7.647l-3.312-.39a.178.178,0,0,0-.185.245l1.009,2.424a51.541,51.541,0,0,0-2.739,6.438c-1.212,3.477-2.548,8.577-2.033,13.133.972,8.652,5.945,75.875,6,76.553a.178.178,0,0,0,.178.165H675a.178.178,0,0,0,.165-.191c-.05-.678-5.024-67.908-6-76.566-.508-4.488.814-9.53,2.013-12.97a50.372,50.372,0,0,1,2.758-6.468.179.179,0,0,0,.008-.153l-.924-2.221,3.241.381a.178.178,0,0,0,.2-.2,16.175,16.175,0,0,0-3.9-8.068.178.178,0,0,0-.252-.015",
    transform: "translate(-556.496 -384.056)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424171",
    "data-name": "Path 424171",
    d: "M543.458,478.1l-.3-3.3a.178.178,0,0,0-.28-.13l-3.52,2.469a27.938,27.938,0,0,1,.007-9.947.178.178,0,0,0-.35-.069,28.163,28.163,0,0,0,.048,10.358.178.178,0,0,0,.276.107l3.491-2.448.286,3.115a.178.178,0,0,0,.132.156c.1.027,10.255,2.769,14.776,9.553a.178.178,0,0,0,.3-.2c-4.326-6.492-13.687-9.332-14.861-9.667",
    transform: "translate(-448.19 -388.623)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424172",
    "data-name": "Path 424172",
    d: "M835.881,672.37c4.463,2.325,13.872,5.728,22.748,5.117-10.766-2.714-21.4-7.324-23.8-9.431a25.687,25.687,0,0,0,1.055,4.313",
    transform: "translate(-694.751 -555.964)",
    fill: "#71c4e3"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424173",
    "data-name": "Path 424173",
    d: "M550.276,331.093a1.592,1.592,0,1,0,2.185.54,1.592,1.592,0,0,0-2.185-.54",
    transform: "translate(-457.305 -275.348)",
    fill: "#1e2d70"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424174",
    "data-name": "Path 424174",
    d: "M562.236,671.809a2.026,2.026,0,0,0-2.757-.75l-28.516,14.405a2.027,2.027,0,0,0-1.034,2.665l20.935,41.442a2.027,2.027,0,0,0,2.758.749l28.516-14.405a2.026,2.026,0,0,0,1.032-2.664Z",
    transform: "translate(-440.857 -558.254)",
    fill: "#1e2d70"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424175",
    "data-name": "Path 424175",
    d: "M558.614,705.308l.325.748-1.722,1.028,20.018,37.328,25.313-11.952-20.78-39.213Z",
    transform: "translate(-463.721 -576.928)",
    fill: "#d9eef5"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424176",
    "data-name": "Path 424176",
    d: "M560.058,712.566c3.469,6.623,20.382,35.341,20.382,35.341s18.191-8.2,23.781-13.82l-20.891-33.975Z",
    transform: "translate(-466.086 -582.641)",
    fill: "#fff"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424177",
    "data-name": "Path 424177",
    d: "M603.115,717.005c-4.925-3.595-14.419-23.757-14.419-23.757l-23.154,12.06s15.57,22.6,19.012,26.852,8.6,1.822,8.6,1.822,11.54-9.1,13.444-12.635c1.673-3.418-1.49-7.122-1.953-7.948a16.056,16.056,0,0,1-1.535,3.606",
    transform: "translate(-470.65 -576.928)",
    fill: "#fff"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424178",
    "data-name": "Path 424178",
    d: "M593.25,687.928c-1.481-.164-3.042-2.889-5.756-1.521-2.625,1.323-1.36,4.012-1.7,5.4s-4.737,3.558-2.83,7.108c3.2-1.522,14.79-7.33,17.961-9.236-1.662-3.784-6.2-1.583-7.679-1.747",
    transform: "translate(-484.756 -570.917)",
    fill: "#6eb9e4"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424179",
    "data-name": "Path 424179",
    d: "M730.438,829.426a4.612,4.612,0,0,1-1.917,4.329c5.233-2.336,12.579-10.9,13.628-12.425s.824-4.579-1.86-8.083c-.553,2.563-6.973,13.854-9.851,16.18",
    transform: "translate(-606.283 -676.792)",
    fill: "#d9eef5"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424180",
    "data-name": "Path 424180",
    d: "M594.053,788.156a.215.215,0,0,0-.2.226,4.167,4.167,0,0,1-2.158,4.177,6.34,6.34,0,0,1-6.5-.77c-3.374-2.6-17.859-22.176-20.18-27.827a.215.215,0,0,0-.4.163c2.335,5.685,16.917,25.384,20.315,28a7.1,7.1,0,0,0,4.274,1.431,5.79,5.79,0,0,0,2.686-.621,4.576,4.576,0,0,0,2.388-4.58.214.214,0,0,0-.226-.2",
    transform: "translate(-469.866 -635.666)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424181",
    "data-name": "Path 424181",
    d: "M710.425,834.065c-.191.115-.154.357-.115.614.025.166.067.444,0,.527l-.012.013a1.208,1.208,0,0,1-.261-.258c-.137-.163-.254-.3-.431-.264a.274.274,0,0,0-.2.213c-.138.509.223,1.052.571,1.576.489.736.76,1.213.4,1.613-.083.093-.371-.086-.509-.171l-.1-.058a14.548,14.548,0,0,1-1.948-1.811c-.921-.95-1-1.027-1.192-.894-.258.174-.2.587-.1.982a6.139,6.139,0,0,0,.39.932,6.386,6.386,0,0,1,.519,1.318l-.014-.01a.734.734,0,0,0-.509-.216.347.347,0,0,0-.233.142c-.107.145-.072.35-.028.608a2,2,0,0,1,.041.379,2.972,2.972,0,0,1-.387-.326c-.3-.281-.482-.44-.669-.428a.279.279,0,0,0-.2.1c-.335.4,0,1,.347,1.637.288.523.615,1.116.386,1.318-.042,0-.166-.035-.516-.36-.034-.032-.063-.058-.084-.077-.288-.247-.76-.749-1.216-1.234-.879-.935-1.122-1.175-1.288-1.216a.322.322,0,0,0-.312.083c-.24.24-.1.875-.1.881.032.129.091.32.16.542a5.848,5.848,0,0,1,.4,1.877.175.175,0,0,1-.032.055.569.569,0,0,1-.176-.043.487.487,0,0,0-.654.152,1.03,1.03,0,0,0-.018.6c.008.064.019.15.026.226-.044-.037-.09-.077-.125-.108-.206-.182-.384-.34-.583-.293a.3.3,0,0,0-.213.191c-.153.377.138.814.447,1.276.292.437.622.931.44,1.226-.045,0-.208-.04-.646-.44l-.04-.036a16.534,16.534,0,0,1-1.159-1.188c-.246-.27-.5-.549-.76-.809-.021-.022-.05-.054-.083-.091-.256-.287-.643-.72-1-.578-.385.153-.185.753-.1,1.009l.01.03a4.4,4.4,0,0,0,.314.681c.228.436.572,1.095.438,1.365a.215.215,0,0,0,.385.19c.23-.466-.128-1.15-.443-1.754a4.269,4.269,0,0,1-.284-.608l-.013-.04a1.763,1.763,0,0,1-.108-.455,2.036,2.036,0,0,1,.483.447c.039.043.071.08.1.107.254.255.506.531.749.8a16.943,16.943,0,0,0,1.19,1.219l.036.033a1.722,1.722,0,0,0,.943.552.435.435,0,0,0,.056,0,.4.4,0,0,0,.29-.182c.35-.531-.068-1.156-.437-1.708a3.278,3.278,0,0,1-.4-.706c.038.032.076.065.106.092.193.17.357.318.544.309a.289.289,0,0,0,.21-.1c.126-.15.094-.4.056-.7a2.447,2.447,0,0,1-.028-.331,1.04,1.04,0,0,1,.135.04.518.518,0,0,0,.743-.253,4.455,4.455,0,0,0-.382-2.169c-.067-.215-.124-.4-.153-.516a1.752,1.752,0,0,1-.024-.374c.217.192.658.661,1,1.02.464.494.945,1,1.25,1.266.018.016.043.039.072.065.255.237.728.677,1.076.377.5-.436.089-1.191-.278-1.857a2.876,2.876,0,0,1-.432-1.039c.088.069.2.178.284.252.285.266.469.429.654.448a.389.389,0,0,0,.34-.116c.169-.182.118-.483.068-.773-.01-.061-.024-.141-.031-.206.042.028.088.063.119.087.158.119.321.243.5.17a.336.336,0,0,0,.2-.285,3.912,3.912,0,0,0-.559-1.719,6.043,6.043,0,0,1-.364-.864,2.709,2.709,0,0,1-.061-.312c.169.164.409.412.631.64a14.2,14.2,0,0,0,2.04,1.884l.084.051c.256.159.732.455,1.056.093.606-.677.091-1.453-.364-2.137a4.225,4.225,0,0,1-.479-.846.657.657,0,0,0,.454.25h0a.428.428,0,0,0,.335-.177,1.125,1.125,0,0,0,.088-.86l-.009-.061.006,0a.215.215,0,1,0,.256-.345c-.188-.14-.386-.254-.562-.149m-7.479,5.058Zm-1.11,3.916h0",
    transform: "translate(-581.22 -694.084)",
    fill: "#e87255"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424182",
    "data-name": "Path 424182",
    d: "M599.566,762.372l2.9,5.341,4.443-2.416-2.9-5.341Z",
    transform: "translate(-498.965 -632.443)",
    fill: "#e2f7ff"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424183",
    "data-name": "Path 424183",
    d: "M696.85,773.114l2.166,3.738,1.236-.716-2.164-3.739Z",
    transform: "translate(-579.926 -642.797)",
    fill: "#e87255"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199412",
    "data-name": "Rectangle 199412",
    width: 1.428,
    height: 2.962,
    transform: "translate(119.205 130.55) rotate(-30.07)",
    fill: "#6eb9e4"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424184",
    "data-name": "Path 424184",
    d: "M690.592,784.521l1.61,2.783,1.238-.717-1.612-2.782Z",
    transform: "translate(-574.718 -652.291)",
    fill: "#6eb9e4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199413",
    "data-name": "Rectangle 199413",
    width: 1.428,
    height: 2.139,
    transform: "matrix(0.865, -0.501, 0.501, 0.865, 114.783, 134.121)",
    fill: "#6eb9e4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199414",
    "data-name": "Rectangle 199414",
    width: 9.327,
    height: 0.429,
    transform: "translate(114.889 136.273) rotate(-30.229)",
    fill: "#3266af"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199415",
    "data-name": "Rectangle 199415",
    width: 6.001,
    height: 0.796,
    transform: "translate(111.269 125.987) rotate(-29.071)",
    fill: "#6eb9e4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199416",
    "data-name": "Rectangle 199416",
    width: 5.999,
    height: 0.796,
    transform: "translate(112.044 127.26) rotate(-29.075)",
    fill: "#6eb9e4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199417",
    "data-name": "Rectangle 199417",
    width: 6.001,
    height: 0.797,
    transform: "translate(113.521 129.834) rotate(-29.075)",
    fill: "#6eb9e4"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199418",
    "data-name": "Rectangle 199418",
    width: 5.999,
    height: 0.796,
    transform: "translate(112.768 128.485) rotate(-29.075)",
    fill: "#6eb9e4"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424185",
    "data-name": "Path 424185",
    d: "M662.044,819.136l.585.854,13.873-9.484-.585-.854Z",
    transform: "translate(-550.96 -673.801)",
    fill: "#6eb9e4"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424186",
    "data-name": "Path 424186",
    d: "M668.246,827.928l.585.854L682.7,819.3l-.585-.854Z",
    transform: "translate(-556.121 -681.118)",
    fill: "#6eb9e4"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424187",
    "data-name": "Path 424187",
    d: "M641.288,804.663c-2.114.412-1.174,2.068-1.61,2.943s-2.512,1.662-1.416,3.248c.719,1.038,3.1-.114,4.164-1.962s-.167-4.42-1.138-4.229",
    transform: "translate(-530.906 -669.641)",
    fill: "#6eb9e4"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424188",
    "data-name": "Path 424188",
    d: "M653.366,793.837a5.276,5.276,0,0,1,.515,2.017l.429.012a5.624,5.624,0,0,0-.554-2.208Z",
    transform: "translate(-543.738 -660.491)",
    fill: "#6eb9e4"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424189",
    "data-name": "Path 424189",
    d: "M637.956,840.937l-.261-.342c-.808.616-.81,1.435-.005,2.576l.351-.247c-.941-1.335-.384-1.759-.085-1.987",
    transform: "translate(-530.191 -699.552)",
    fill: "#6eb9e4"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424190",
    "data-name": "Path 424190",
    d: "M617.24,782.544c-1.334.778-.605,2.235-.124,3.3,1.245-.63,2.25-1.22,3.165-1.705-.66-1.252-1.709-2.372-3.041-1.6",
    transform: "translate(-513.041 -651.028)",
    fill: "#6eb9e4"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424191",
    "data-name": "Path 424191",
    d: "M614.676,773.22a.85.85,0,1,0,1.152.342.851.851,0,0,0-1.152-.342",
    transform: "translate(-511.17 -643.396)",
    fill: "#6eb9e4"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424192",
    "data-name": "Path 424192",
    d: "M558.572,855.19c-2.952,1.6-8.391,4.075-13.838,4.332s-4.178,13.521-1.226,13.649,6.567,1.149,11.493-.205c5.219-1.434,6.238-4.105,3.529-4.023,3.123-1.149,2.916-4.229.207-3.653,3.161-1.956,1.117-4.391-1.732-3.624a7.4,7.4,0,0,1-.8.292,4.855,4.855,0,0,1,.8-.292,19.185,19.185,0,0,0,4.484-3.273c2.132-1.807,2.1-5.917-2.916-3.2",
    transform: "translate(-450.201 -710.948)",
    fill: "#f5bd9f"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424193",
    "data-name": "Path 424193",
    d: "M632.563,898.256a4.835,4.835,0,0,0-.8.292,7.4,7.4,0,0,0,.8-.292",
    transform: "translate(-525.76 -747.538)",
    fill: "#f5bd9f"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424194",
    "data-name": "Path 424194",
    d: "M330.26,517.839c2.189-8.847,3.137-32.685-1.554-30.727-41.428,17.295-41.477,82.432,14.993,82.541.214-3.059.128-11,.378-17.655-14.58,1.663-35.69-15.353-13.817-34.159",
    transform: "translate(-249.06 -405.284)",
    fill: "#0095d9"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424195",
    "data-name": "Path 424195",
    d: "M619.537,898.012a29.187,29.187,0,0,1-3.364,1.072.178.178,0,0,0,.091.345,28.531,28.531,0,0,0,3.438-1.1.178.178,0,1,0-.164-.316",
    transform: "translate(-512.675 -747.318)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424196",
    "data-name": "Path 424196",
    d: "M624.1,918.915a20.164,20.164,0,0,1-4.43,1.469.178.178,0,0,0,.037.353.173.173,0,0,0,.038,0,20.154,20.154,0,0,0,4.525-1.5.178.178,0,0,0-.17-.313",
    transform: "translate(-515.576 -764.712)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424197",
    "data-name": "Path 424197",
    d: "M625.691,940.034a14.717,14.717,0,0,1-3.934,1.415.178.178,0,0,0,.028.354l.029,0a14.9,14.9,0,0,0,4.051-1.455.178.178,0,0,0-.174-.311",
    transform: "translate(-517.308 -782.288)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424198",
    "data-name": "Path 424198",
    d: "M330.006,864.658c11.166,18.057,27.4,18.6,39.446,18.383a34.8,34.8,0,0,0-.05-3.6c-16.947.555-26.915-1.712-39.4-14.783",
    transform: "translate(-274.634 -719.577)",
    fill: "#71c4e3"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424199",
    "data-name": "Path 424199",
    d: "M453.6,807.093c-15.29-.239-19.867-6.323-22.328-12.244a.178.178,0,0,0-.329.137c2.505,6.027,7.156,12.222,22.652,12.464h0a.178.178,0,0,0,0-.357",
    transform: "translate(-358.624 -661.39)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199419",
    "data-name": "Rectangle 199419",
    width: 95.975,
    height: 0.368,
    transform: "translate(59.532 180.14)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199420",
    "data-name": "Rectangle 199420",
    width: 95.975,
    height: 17.715,
    transform: "translate(59.532 180.536)",
    fill: "#fff"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424200",
    "data-name": "Path 424200",
    d: "M777.9,443.915c-.29.054-.724.143-1.289.258a227.1,227.1,0,0,1-45.423,4.9c-26.5-.1-45.723-6.288-57.144-18.4a.713.713,0,1,0-1.037.978c11.7,12.41,31.273,18.752,58.176,18.851h.628a228.579,228.579,0,0,0,45.083-4.934c.557-.113.985-.2,1.271-.254a.713.713,0,1,0-.265-1.4",
    transform: "translate(-559.92 -358.225)",
    fill: "#3266af"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424201",
    "data-name": "Path 424201",
    d: "M504.335,362.6c-1.175-1.608-3.13-1.628-3.823-3.361-1.993,3.043-4.555,2.976-4.6,6.848a7.627,7.627,0,0,0,.182,1.607c-.324-.112-.65-.231-.989-.366-.037-.015-.083-.031-.136-.048-.682.491-1.378.966-2.07,1.438a9.565,9.565,0,0,1-4.232,1.6c-.818,1.3-2.2,2.563-1.673,5.173.761,3.746,3.332,1.522,4.854,2.427s1.733,3.467,4.44,2.908c2.574-.522,4.391-3.113,6.832-3.788,1.219-.217,3.726.374,4.166-2.886.482-3.505-2.148-4.844-2.369-6.5s.6-3.438-.578-5.046",
    transform: "translate(-405.18 -298.961)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424202",
    "data-name": "Path 424202",
    d: "M560.757,352.137c-4.886-3.076-9.966-8.06-10.01-11.076a1.908,1.908,0,0,1,.905-1.72.357.357,0,1,0-.4-.592,2.605,2.605,0,0,0-1.22,2.322c.05,3.381,5.367,8.535,10.343,11.668a.352.352,0,0,0,.19.055.356.356,0,0,0,.19-.658",
    transform: "translate(-457.743 -281.86)",
    fill: "#6eb9e4"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424203",
    "data-name": "Path 424203",
    d: "M620.184,385.2c.77,3.636.364,5.561-1.24,6.4s-5.176-.221-9.283-2.8a.713.713,0,0,0-.763,1.2c1.775,1.119,5.647,3.308,8.67,3.308a4.268,4.268,0,0,0,2.039-.449c3.059-1.611,2.688-5.525,1.547-9.76a16.282,16.282,0,0,1-.97,2.1",
    transform: "translate(-506.458 -318.821)",
    fill: "#3266af"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424204",
    "data-name": "Path 424204",
    d: "M481.445,311.829c-.119-.072-.239-.146-.361-.22a5.058,5.058,0,0,0-3.56-1.111,12.8,12.8,0,0,0-1.681.511c-1.777.628-3.455,1.222-4.622-.727s-.2-3.856.739-5.7a11.892,11.892,0,0,0,1.18-2.916,4.565,4.565,0,0,0-.914-3.35,6.1,6.1,0,0,1-.981-2.4c-.265-2.389.248-3.681,2.291-5.76a7.471,7.471,0,0,0,1.967-4.292c.005-.357.009-.691.012-1.006.041-3.741.049-4.519,2.186-5.389a2.97,2.97,0,0,0,.724-.477,1.817,1.817,0,0,1,1.031-.531.178.178,0,1,0,0-.356,2.1,2.1,0,0,0-1.254.61,2.692,2.692,0,0,1-.634.424c-2.358.96-2.369,1.967-2.41,5.716q0,.471-.012,1a7.121,7.121,0,0,1-1.865,4.048c-2.108,2.146-2.667,3.559-2.39,6.048a6.373,6.373,0,0,0,1.028,2.538,4.23,4.23,0,0,1,.872,3.1,11.467,11.467,0,0,1-1.148,2.824c-.982,1.933-2,3.931-.727,6.047,1.316,2.2,3.3,1.5,5.046.88a12.351,12.351,0,0,1,1.632-.5,4.726,4.726,0,0,1,3.3,1.065c.123.076.244.15.364.222a.178.178,0,1,0,.184-.305",
    transform: "translate(-391.405 -231.443)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424205",
    "data-name": "Path 424205",
    d: "M597.8,1126.59a9.184,9.184,0,1,0,9.188,9.184,9.193,9.193,0,0,0-9.188-9.184",
    transform: "translate(-489.853 -937.56)",
    fill: "#e6423a"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424206",
    "data-name": "Path 424206",
    d: "M613.57,1161.743c-3.718.023-5.84,2.041-5.86,5.5,1.068-.047,2.841.023,3.763,0a3.656,3.656,0,0,0-.218-1.612c-.178-.235.587-.818,2.248-.829,1.635-.01,2.782.628,2.63.849a3.656,3.656,0,0,0-.33,1.6c.718,0,2.933.018,3.764-.028.119-3.657-2.281-5.51-6-5.487",
    transform: "translate(-505.743 -966.815)",
    fill: "#fff"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424207",
    "data-name": "Path 424207",
    d: "M451.919,1161.723h-4.212a1.592,1.592,0,0,0-1.6,1.591v3.506a1.592,1.592,0,0,0,1.6,1.591h4.212a1.592,1.592,0,0,0,1.6-1.591v-3.506a1.592,1.592,0,0,0-1.6-1.591",
    transform: "translate(-371.259 -966.798)",
    fill: "#6383db"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424208",
    "data-name": "Path 424208",
    d: "M474.278,1169.378l5.326,2.2-.013-4.579Z",
    transform: "translate(-394.699 -971.188)",
    fill: "#6383db"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424209",
    "data-name": "Path 424209",
    d: "M803.763,1151.04a1.922,1.922,0,0,0-1.921,1.92v3.43a1.921,1.921,0,0,0,3.841,0v-3.43a1.922,1.922,0,0,0-1.921-1.92",
    transform: "translate(-667.301 -957.908)",
    fill: "#6383db"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424210",
    "data-name": "Path 424210",
    d: "M797.33,1180.2a.407.407,0,0,0-.407.407,3,3,0,1,1-6.007,0,.407.407,0,0,0-.814,0,3.817,3.817,0,1,0,7.634,0,.407.407,0,0,0-.407-.407",
    transform: "translate(-657.532 -982.174)",
    fill: "#6383db"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424211",
    "data-name": "Path 424211",
    d: "M810.689,1200.522a.407.407,0,0,0-.407.407v2.772a.407.407,0,1,0,.814,0v-2.772a.407.407,0,0,0-.407-.407",
    transform: "translate(-674.325 -999.087)",
    fill: "#6383db"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424225",
    "data-name": "Path 424225",
    d: "M1089.16,1242.985l-.225.006a1.3,1.3,0,0,0,.225-.006",
    transform: "translate(-906.223 -1034.425)",
    fill: "#fff"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424228",
    "data-name": "Path 424228",
    d: "M1106.1,1.063a18.466,18.466,0,1,0,18.612,18.465A18.538,18.538,0,0,0,1106.1,1.063",
    transform: "translate(-905.021 -0.885)",
    fill: "#fff"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424229",
    "data-name": "Path 424229",
    d: "M1105.214,37.288a18.645,18.645,0,1,1,0-37.288A18.738,18.738,0,0,1,1124,18.643a18.739,18.739,0,0,1-18.79,18.645m0-36.932a18.288,18.288,0,1,0,18.434,18.287A18.379,18.379,0,0,0,1105.214.357",
    transform: "translate(-904.137 0)",
    fill: "#859fff"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424230",
    "data-name": "Path 424230",
    d: "M1122.026,19.011a15.214,15.214,0,1,0,15.216,15.214,15.213,15.213,0,0,0-15.216-15.214",
    transform: "translate(-921.103 -15.821)",
    fill: "#fff"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424231",
    "data-name": "Path 424231",
    d: "M1121.141,48.732a15.392,15.392,0,1,1,15.394-15.392,15.408,15.408,0,0,1-15.394,15.392m0-30.428a15.036,15.036,0,1,0,15.037,15.036A15.051,15.051,0,0,0,1121.141,18.3",
    transform: "translate(-920.218 -14.937)",
    fill: "#859fff"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424232",
    "data-name": "Path 424232",
    d: "M1175.321,63.323l7.155,1.58-11.561-12.725Z",
    transform: "translate(-974.447 -43.423)",
    fill: "#fff"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424233",
    "data-name": "Path 424233",
    d: "M1170.258,51.787l-.332.131,4.406,11.145.035.088,7.247,1.6.077-.348-7.062-1.56Z",
    transform: "translate(-973.624 -43.098)",
    fill: "#859fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellnessFeatureCallDoctor);
export default __webpack_public_path__ + "static/media/wellness-feature-call-doctor.047f73883bef7c3bae055ae365b214f4.svg";
export { ForwardRef as ReactComponent };